import { useState, useEffect } from 'react';
import { $getSelection, $isRangeSelection, FORMAT_TEXT_COMMAND } from 'lexical';
import { useRichTextEditor } from '../RichTextEditorProvider';
import { IconButton, Tooltip } from '@sweep-io/sweep-design';
import { TextItalic } from '@sweep-io/sweep-design/dist/icons';

export const ItalicButton = () => {
  const { editor } = useRichTextEditor();
  const [isItalic, setIsItalic] = useState(false);

  useEffect(() => {
    return editor.registerUpdateListener(({ editorState }: any) => {
      editorState.read(() => {
        const selection = $getSelection();
        if ($isRangeSelection(selection)) {
          setIsItalic(selection.hasFormat('italic'));
        }
      });
    });
  }, [editor]);

  return (
    <Tooltip title="Italic (Ctrl+I)">
      <IconButton
        variant="squared"
        size="small"
        onClick={() => {
          editor.dispatchCommand(FORMAT_TEXT_COMMAND, 'italic');
        }}
        pressed={isItalic}
      >
        <TextItalic />
      </IconButton>
    </Tooltip>
  );
};
